import React from 'react';
import classnames from 'classnames';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Translate } from 'react-localize-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { bindActionCreators } from 'redux';
import { repiActions } from '../../../store/repiStore';
import { isNullOrUndefined } from '../../../store/storeFunctions';

import FoIcon from '../../../img/icons/FyzickaOsoba';
import PoIcon from '../../../img/icons/PravnickaOsoba';
import FopIcon from '../../../img/icons/FyzickaOsobaPodnikatel';

import '../repi.scss'

class RepiSubjectInfo extends React.Component {
    state = {
        currentSubject: null
    };

    render() {
        const { subjectId } = this.props.getRepiProps();
        const subjectInfo = this.props.subjectInfos[subjectId];

        if (isNullOrUndefined(subjectInfo) || subjectInfo.isRequesting || isNullOrUndefined(subjectInfo.result))
            return (<div><span>REPI</span></div>);

        const Icon = this.getIcon(subjectInfo.result.subjectType);
        const hasName = !isNullOrUndefined(subjectInfo.result.name);
        const hasBirthDate = subjectInfo.result.subjectType < 3 && !isNullOrUndefined(subjectInfo.result.birthDate);
        const hasIdentification = !isNullOrUndefined(subjectInfo.result.identification)

        return (
            <div className="subject-info-wrapper">
                <div className="repi-header-main-label hide-on-mobile">REPI</div>
                <div className="subject-info-angle hide-on-mobile"><FontAwesomeIcon icon='angle-right' /></div>
                <Icon className="subject-info-icon svg-standard-fill"/>
                {hasName && <div>{subjectInfo.result.name}</div>}
                {hasBirthDate && <>
                    {hasName && <div className={classnames("normal-font separator", { "hide-on-mobile": hasName })}>|</div>}
                    <div className={classnames("normal-font", { "hide-on-mobile": hasName })}><Translate id="Repi.Search.BirthDate" />:&nbsp;</div>
                    <div className={classnames("normal-font", { "hide-on-mobile": hasName })}>{subjectInfo.result.birthDate}</div>
                </>}
                {hasIdentification && <>
                    {(hasName || hasBirthDate) && <div className={classnames("normal-font separator", { "hide-on-mobile": hasName })}>|</div>}
                    <div className={classnames("normal-font", { "hide-on-mobile": hasName || hasBirthDate })}>
                        <Translate id={`Repi.Search.${(subjectInfo.result.isPin ? "Pin" : "CompanyId")}.Short`} />:&nbsp;
                    </div>
                    <div className={classnames("normal-font", { "hide-on-mobile": hasName })}>{subjectInfo.result.identification}</div>
                </>}
            </div>
        );
    }

    componentDidMount() {
        const { subjectId } = this.props.getRepiProps();
        this.props.ensureSubjectInfo(subjectId);
        this.setState({ currentSubject: subjectId });
    }

    componentDidUpdate() {
        const { subjectId } = this.props.getRepiProps();
        if (this.state.currentSubject !== subjectId) {
            this.props.ensureSubjectInfo(subjectId);
            this.setState({ currentSubject: subjectId });
        }
    }

    getIcon = (subjectType) => {
        switch (subjectType) {
            case 1: return FoIcon;
            case 2: return FopIcon;
            case 3: return PoIcon;
            default: return null;
        }
    }
}

export default withRouter(connect(
    state => ({ subjectInfos: state.repi.subjectInfos }),
    dispatch => bindActionCreators(repiActions, dispatch)
)(RepiSubjectInfo));